import { Button } from "react-bootstrap";
import { ReactComponent as Logo } from "../../assets/img/logo_autobiztrade.svg";
import { t } from "../../services/translate";

const FullPageErrorFallback = ({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) => {
  return (
    <div className="vh-100 d-flex flex-column align-items-center bg-dark text-white" role="alert">
      <Logo className="mt-5" />
      <h2 className="mt-3">{t("somethingWrong")}</h2>
      <pre className="text-light">{t(error.message)}</pre>
      <Button variant="primary" onClick={() => resetErrorBoundary()}>
        {t("tryagain")}
      </Button>
    </div>
  );
};

export default FullPageErrorFallback;
